import { Component, OnInit, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { UserStandingdataModel } from "@app/user/user-maintenance/shared/user-standingdata-model";
import { UserMaintenancePermissionModel } from "@models/permissions/UserMaintenancePermissionModel";
import { UserDetailModel } from "@app/user/user-maintenance/shared/user-detail-model";
import { Language } from "@app/user/user-profile/shared/language.enum";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { Observable, defer, map } from "rxjs";
import { scope } from "@app/user/i18n/scope";
import { CerrixTextfieldComponent } from "@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component";
import { CerrixSelectTreeComponent } from "@app/shared/cerrix-select-tree/cerrix-select-tree.component";
import { CerrixSelectComponent } from "@app/shared/cerrix-select/cerrix-select.component";
import { CerrixTextAreaComponent } from "@app/shared/components/cerrix-textinput/cerrix-textarea/cerrix-textarea.component";

@Component({
    selector: "user-info",
    templateUrl: "./user-info.component.html",
    styleUrls: ["./user-info.component.scss"],
    imports: [
        FormsModule,
        MatTooltipModule,
        CerrixTextfieldComponent,
        CerrixSelectTreeComponent,
        CerrixSelectComponent,
        CerrixTextAreaComponent,
        TranslatePipe,
    ],
    viewProviders: [provideTranslationScope(scope)]
})
export class UserInfoComponent implements OnInit {
    @Input() user: UserDetailModel;
    @Input() sd: UserStandingdataModel;
    @Input() permissions: UserMaintenancePermissionModel;

    private _translation = injectTranslation(scope);

    // "Use tenant default" is keyed as 0, not null: cerrix-select's writeValue treats a
    // null bindValue as "not defined" and refuses to select it. The Language enum has no
    // 0 member, so 0 is a safe sentinel; languageSelectValue converts to/from it.
    // The labels wait for the scope to load; cerrix-select subscribes to the observable.
    languageOptions: Observable<{ ID: Language | 0; Name: string }[]> = defer(() =>
        this._translation.ready()
    ).pipe(
        map(() => [
            { ID: 0, Name: this._translation.t("info.languageTenantDefault") },
            { ID: Language.English, Name: this._translation.t("info.languageEnglish") },
            { ID: Language.Dutch, Name: this._translation.t("info.languageDutch") },
            { ID: Language.Norwegian, Name: this._translation.t("info.languageNorwegian") },
        ])
    );

    constructor() {}

    ngOnInit() {}

    get languageSelectValue(): Language | 0 {
        return this.user.language ?? 0;
    }

    set languageSelectValue(value: Language | 0) {
        this.user.language = value || null;
    }
}
